import type { StatItem } from "../../types/analytics"

interface StatCardProps {
  label: string
  stat: StatItem | undefined
  unit?: string
  formatter?: (v: number) => string
  tooltip?: string
}

const defaultFormat = (v: number) => v.toLocaleString()

const StatCard = ({ label, stat, unit = "", formatter = defaultFormat, tooltip }: StatCardProps) => {
  const value      = stat?.value
  const changeRate = stat?.change_rate

  const changeClass =
    changeRate == null ? "stat-card__change--neutral"
    : changeRate > 0   ? "stat-card__change--up"
    : changeRate < 0   ? "stat-card__change--down"
    :                    "stat-card__change--neutral"

  const changeArrow =
    changeRate == null ? "" : changeRate > 0 ? "▲" : changeRate < 0 ? "▼" : ""

  return (
    <div className="stat-card">
      <div className="stat-card__label-wrap">
        <span className="stat-card__label">{label}</span>
        {tooltip && (
          <span className="stat-card__tooltip-wrap">
            <i className="bi bi-info-circle stat-card__tooltip-icon" />
            <span className="stat-card__tooltip">{tooltip}</span>
          </span>
        )}
      </div>
      <div className="stat-card__value">
        {value != null ? `${formatter(value)}${unit}` : "—"}
      </div>
      {changeRate != null && (
        <div className={`stat-card__change ${changeClass}`}>
          {changeArrow} {Math.abs(changeRate)}% 前月比
        </div>
      )}
    </div>
  )
}

export default StatCard
